import _ from "lodash";

const debugHosts = ["localhost", "tp-portal-dev.appspot.com"];

export default () => _.includes(debugHosts, window.location.hostname);
